import { Validators } from '@angular/forms';
import { ControlProperty } from '../../../../../common/models';
import { LocalDateModel, LocalDateRangeModel } from '../../../../models';
import { AllocationDetailsModel } from './allocation-details';

export class AllocationViewTimeslot {
  dockId: number;
  dockName: string;
  durationInMins: number;
  end: number;
  start: number;

  constructor(params?: AllocationViewTimeslot) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocationViewTimeslotInputModel {
  dockId: number;
  dockName: string;
  durationInMins: number;
  end: number;
  start: number;
  minServiceTime: number;
  maxServiceTime: number;

  constructor(params?: AllocationViewTimeslotOutputModel) {
    if (params) {
      const { timeSlot, ...rest } = params;
      Object.assign(this, rest);

      this.start = timeSlot.start.timestamp;
      this.end = timeSlot.end.timestamp;
    }
  }
}

export class AllocationViewTimeslotOutputModel {
  dockId: number;
  dockName: string;
  durationInMins: number;
  timeSlot: LocalDateRangeModel;

  constructor(params?: AllocationViewTimeslot, timezone?: string) {
    if (params) {
      const { start, end, ...rest } = params;

      Object.assign(this, rest);

      this.timeSlot = Object.assign(new LocalDateRangeModel(), {
        start: Object.assign(new LocalDateModel(), {
          timestamp: +start,
          timezone,
          resolved: true,
        }),
        end: Object.assign(new LocalDateModel(), {
          timestamp: +end,
          timezone,
          resolved: true,
        }),
      });
    }
  }
}

export class AllocationViewTimeslotForm {
  constructor(
    model: AllocationViewTimeslot,
    public dockId: ControlProperty<number> = [model.dockId, [Validators.required]],
    public dockName: ControlProperty<string> = model.dockName,
    public start: ControlProperty<number | Date> = [
      { disabled: !model.dockId, value: model.start },
      [Validators.required],
    ],
    public end: ControlProperty<number | Date> = [{ disabled: !model.dockId, value: model.end }, [Validators.required]],
    public durationInMins: ControlProperty<number> = [
      {
        disabled: true,
        value: model.durationInMins,
      },
      [Validators.required],
    ],
  ) {}
}

export class AllocationViewTimeslotRequestModel {
  compartmentId: number;
  dockId: number;
  details: AllocationDetailsModel;

  constructor(params?: AllocationViewTimeslotRequestModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}
